import Cookies from 'js-cookie';
const myBaseUrl = process.env.VUE_APP_BASE_API;

function setCookie() {
  const activeUser = localStorage.getItem('activeUser');
  if (activeUser) {
    const user = JSON.parse(activeUser);
    Cookies.set('tld-token', user.pdToken);
  }
}

/**
 * 通用请求封装方法
 * @param {string} pdUrl - 接口路径
 * @param {Object} data - 请求参数
 * @param {Object} options - 额外选项，可包含 signal (AbortSignal)
 * @returns {Promise}
 */
const requestPDServer = (pdUrl, data, options = {}) => {
  return new Promise((resolve, reject) => {
    const activeUser = localStorage.getItem('activeUser');
    const pdUserId = activeUser ? JSON.parse(activeUser).id : null;
    setCookie();

    if (data) {
      if (data.idInterlocutor) {
        data.idInterlocutor = Number(data.idInterlocutor);
      }
      if (data.idRegularUser) {
        data.idRegularUser = Number(data.idRegularUser);
      }
      if (data.idUser) {
        data.idUser = Number(data.idUser);
      }
      if (data.idUserFrom) {
        data.idUserFrom = Number(data.idUserFrom);
      }
      if (data.idUserTo) {
        data.idUserTo = Number(data.idUserTo);
      }
    }
    
    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        pdCookies:
          data?.pdToken ||
          (() => {
            const activeUser = localStorage.getItem('activeUser');
            return activeUser ? JSON.parse(activeUser).pdToken : null;
          })(),
        Authorization: 'Bearer ' + localStorage.getItem('Admin-Token'),
        ...options.headers,
      },
      body: JSON.stringify({
        paramJson: data,
        pdUserId,
      }),
    };
    
    // 如果提供了 signal，添加到 fetch 选项
    if (options.signal) {
      fetchOptions.signal = options.signal;
    }
    
    return fetch(`${myBaseUrl}/requestPDServer?pdUrl=${pdUrl}`, fetchOptions)
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        // 如果是取消请求，不 reject，直接返回
        if (err.name === 'AbortError') {
          return;
        }
        reject(err);
      });
  });
};

// 公共的fetch响应处理方法
const handleFetchResponse = async (response, resolve, reject) => {
  // console.log('handleFetchResponse - status:', response.status);
  const isSuccess = response.status >= 200 && response.status < 300;

  // console.log('handleFetchResponse - isSuccess:', isSuccess);

  try {
    // 直接尝试解析JSON，如果失败则说明响应体为空
    const data = await response.json();
    // console.log('handleFetchResponse - parsed data:', data);
    if (isSuccess) {
      // console.log('handleFetchResponse - resolving with data');
      if (data.code) {
        if (data.code === 200) {
          resolve(data);
        } else {
          reject(data);
        }
      } else {
        resolve(data);
      }
    } else {
      // console.log('handleFetchResponse - rejecting with data');
      reject(data);
    }
  } catch (error) {
    //  console.log(
    //   'handleFetchResponse - JSON parse error, treating as empty response'
    // );
    // JSON解析失败，说明响应体为空
    resolve(isSuccess ? { status: response.status } : {});
  }
};
// 检查流是否为空的方法
const checkStreamEmpty = async (response) => {
  const clone = response.clone(); // 克隆响应以避免消耗原始流
  const reader = clone.body.getReader();
  const { done, value } = await reader.read();
  reader.releaseLock();

  if (done || !value || value.length === 0) {
    // console.log('Stream is empty');
    return true;
  } else {
    // console.log('Stream has data, length:', value.length);
    return false;
  }
};

export { requestPDServer, handleFetchResponse };
